import { render, staticRenderFns } from "./ShippingForm.vue?vue&type=template&id=c198396a&scoped=true"
import script from "./ShippingForm.vue?vue&type=script&lang=js"
export * from "./ShippingForm.vue?vue&type=script&lang=js"
import style0 from "./ShippingForm.vue?vue&type=style&index=0&id=c198396a&prod&lang=scss&scoped=true"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c198396a",
  null
  
)

export default component.exports